export default __webpack_public_path__ + "static/media/Group 78.27b3fa22.svg";